export default async function getMediaPermissions() {
  const devices = await navigator.mediaDevices.enumerateDevices()
  const audio   = devices.some(dev => dev.kind === 'audioinput' && dev.label !== '');
  const video   = devices.some(dev => dev.kind === 'videoinput' && dev.label !== '');
  
  return { audio, video };
}